import { connect } from 'react-redux';
import * as actions from './actions';
import * as addressBookActions from '../EmailAddressBook/actions'
import Invitations from './Invitations';

const mapStateToProps = (state, ownProps) => {
  return {
    isFetching: state.invitations.isFetchingList,
    invitations: state.invitations.invitations,
    errors: state.invitations.errors,
    success: state.invitations.success,
    hasServerError: state.invitations.hasServerError,
    emailAddressBook: state.emailAddressBook.emailAddressBook,
    hasFecthedEmailAddressBook: state.emailAddressBook.hasFetchedEmailAddressBook,
    hasFetchedGroups: state.emailAddressBook.hasFetchedGroups,
    groups: state.emailAddressBook.groups,
    user: state.loginLayout.user,
    domainDetails: state.planDetails,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  fetchInvitations: (token, isWebinar) => dispatch(actions.getInvitations(token, isWebinar)),
  clearErrors: () => dispatch(actions.clearErrors()),
  fetchAddressBook: (token) => dispatch(addressBookActions.fetchEmailAddressBook(token)),
  fetchGroups: (token) => dispatch(addressBookActions.fetchGroups(token))
})

const InvitationContainer = connect(mapStateToProps, mapDispatchToProps)(Invitations);

export default InvitationContainer;


// WEBPACK FOOTER //
// src/routes/Invitations/InvitationsContainer.js